import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const ModalAddress = () => {
    return (
        <div className="modal-address-wrapper modal-send-product" id="modal-address-user">
            <div className="modal-box">
                <div className="close-icon position-absolute modal-close-send-product" id="close-modal-information-user">
                    <IconName name="expand_close" className="icon"/>
                </div>
                <div className="title xmb-2">
                    <div className="title-box just-text title-box-blue">
                        <div className="title-bg">
                            <h2 className="text">
                                نشانی جدید
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="content-address-modal">
                    <div className="row">
                        <div className="col-6 xpx-1">
                            <div className="info-address position-relative">
                                <select className="form-select input-normal xmt-4 xmt-lg-6"
                                        aria-label="Default select example">
                                    <option value="1">استان</option>
                                    <option value="21">اصفهان</option>
                                    <option value="3">تهران</option>
                                    <option value="4">فارس</option>
                                </select>
                                <IconName name="expand_more" className="icon position-absolute more-icon"/>
                            </div>
                        </div>
                        <div className="col-6 xpx-1">
                            <div className="info-address position-relative">
                                <select className="form-select input-normal xmt-4 xmt-lg-6"
                                        aria-label="Default select example">
                                    <option value="1">شهر</option>
                                    <option value="21">اصفهان</option>
                                    <option value="3">تهران</option>
                                    <option value="4">شیراز</option>
                                </select>
                                <IconName name="expand_more" className="icon position-absolute more-icon"/>
                            </div>
                        </div>
                        <div className="col-12 xpx-1">
                            <div className="info-address">
                                <input type="text" placeholder="نشانی"
                                       className="form-control input-normal xmt-4 xmt-lg-6"/>
                            </div>
                        </div>
                        <div className="col-6 xpx-1">
                            <div className="info-address">
                                <input type="text" placeholder="پلاک"
                                       className="form-control input-normal xmt-4 xmt-lg-6"/>
                            </div>
                        </div>
                        <div className="col-6 xpx-1">
                            <div className="info-address">
                                <input type="text" placeholder="واحد"
                                       className="form-control input-normal xmt-4 xmt-lg-6"/>
                            </div>
                        </div>
                        <div className="col-lg-6 xpx-1">
                            <div className="info-address">
                                <input type="number" placeholder="کد پستی"
                                       className="form-control input-normal xmt-4 xmt-lg-6"/>
                            </div>
                        </div>
                        <div className="send-address xmb-4 xmb-lg-0 xmt-5 xmt-lg-10">
                            <label className="form-check-label">
                                <input className="form-check-input" type="checkbox" value=""/>
                                <span className="text">ارسال برای دیگری</span>
                            </label>
                        </div>
                        <div className="col-6 xpx-1 col-lg-4">
                            <div className="info-address">
                                <input type="text" placeholder="نام گیرنده"
                                       className="form-control input-normal xmt-4 xmt-lg-6"/>
                            </div>
                        </div>
                        <div className="col-6 xpx-1 col-lg-4">
                            <div className="info-address">
                                <input type="text" placeholder="نام خانوادگی گیرنده"
                                       className="form-control input-normal xmt-4 xmt-lg-6"/>
                            </div>
                        </div>
                        <div className="col-lg-4 xpx-1">
                            <div className="info-address">
                                <input type="number" placeholder="شماره موبایل"
                                       className="form-control input-normal xmt-4 xmt-lg-6"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="confirmation-address xp-4 xp-lg-6 xmt-2">
                <div className="button-address"><span className="text">تایید و ثبت نشانی</span></div>
            </div>
        </div>
    );
};

export default ModalAddress;
